import { IAdminSearchParams } from './interface';

export const HEAD_TABLE_PROPS = [
  { id: 'id', label: 'ID', align: 'center' },
  { id: 'name', label: 'Họ tên', align: 'center' },
  { id: 'username', label: 'Tài khoản/Email', align: 'center' },
  { id: 'status', label: 'Trạng thái', align: 'center' },
  { id: 'action', label: 'Action', align: 'center' },
];

export const DEFAULT_SEARCH_VALUE: IAdminSearchParams = {
  searchText: '',
  status: '',
};
